/**
 * @ngdoc service
 * @name proximus.core.service:EncryptionService
 * @description
 * # EncryptionService
 * Encrypts/decrypts entity data
 */
export default class EncryptionService {
    constructor(configurationService) {
        this.configurationService = configurationService;
    }
    /**
     * decrypts Cypher Text
     * @memberof proximus.core.proxy:EncryptionService
     * @param {String} encrypted text
     * @param {String} encryption key
     * @returns {String} plain text
     */
    decryptCypherText(cypherText, key) {
        if (key === undefined || key === '' || cypherText === undefined || cypherText === '') {
            return '';
        }
        const selectedEncryptionService = this.configurationService.getSelectedEncryptionStrategy();
        if (!selectedEncryptionService.decrypt) {
            throw new Error('selectedEncryptionService error when decrypting');
        }
        return selectedEncryptionService.decrypt(cypherText, key);
    }
    /**
     * encrypts Plain Text
     * @memberof proximus.core.proxy:EncryptionService
     * @param {String} plain text
     * @param {String} encryption key
     * @returns {String} encrypted text
     */
    encryptPlainText(plainText, key) {
        if (key === undefined || key === '' || plainText === undefined || plainText === '') {
            return '';
        }
        const selectedEncryptionService = this.configurationService.getSelectedEncryptionStrategy();
        if (!selectedEncryptionService.encrypt) {
            throw new Error('selectedEncryptionService error when encrypting');
        }
        return selectedEncryptionService.encrypt(plainText, key);
    }
}
